// utils/sidebarToggle.ts
export function toggleSidebarSmart(
  mode: string,
  {
    sideBarMode,
    secondSideBarMode,
    setSideBarMode,
    setSecondSideBarMode,
    isShift = false,
  }: {
    sideBarMode: string | null
    secondSideBarMode: string | null
    setSideBarMode: (v: any) => void
    setSecondSideBarMode: (v: any) => void
    isShift?: boolean
  },
) {
  // If the mode is already open anywhere, close it there.
  if (sideBarMode === mode) {
    setSideBarMode(null)
    return
  }
  if (secondSideBarMode === mode) {
    setSecondSideBarMode(null)
    return
  }

  // Otherwise open — Shift => secondary, else primary (no duplicates).
  if (isShift) {
    if (sideBarMode === mode) setSideBarMode(null) // de-dupe guard
    setSecondSideBarMode(mode)
  } else {
    if (secondSideBarMode === mode) setSecondSideBarMode(null) // de-dupe guard
    setSideBarMode(mode)
  }
}
